import { encode } from 'html-entities';
import {
  IArea,
  IEnvironment,
  IOrderStatus,
  IPaymentInterval,
  IPreorderStatus,
  IStatusCategory,
} from 'my-poppies-b2b-types';
import { IPaymentIntervalXMonths } from 'my-poppies-b2b-types/dist/types/IPaymentIntervalXMonths';

import { colors } from '@/colors';
import { IPath } from '@/types/IPath';

export const maxPageWidth = 550;

// Note: please keep in sync with the corresponding type definition at ./types/IEnvironment.ts
export const allowedEnvironments: IEnvironment[] = ['development', 'testing', 'staging', 'production'];

// Note: please keep in sync with the corresponding type definition at ./types/IPath.ts
export const allowedPaths: IPath[] = [
  '/',
  '/login',
  '/archive',
  '/account',
  '/options',
  '/positions',
  '/positions/new',
  '/orders?status=ALL_ORDERS',
  '/orders?status=ALL_OPEN_ORDERS',
  '/orders?status=BEING_PREPARED',
  '/orders?status=DELIVERED',
  '/orders?status=FLAWED',
  '/orders?status=NEW',
  '/orders?status=DECLINED',
  '/orders?status=SHIPPED',
  '/orders?status=INTERNAL_ORDER_COMPLETED',
  '/orders/edit-internal',
  `/preorders?status=ALL_PREORDERS`,
  `/preorders?status=ALL_OPEN_PREORDERS`,
  '/preorders?status=PREORDER',
  '/preorders?status=PREORDER_COMPLETED',
  '/payments/new',
  '/payments?month=JANUARY',
  '/payments?month=FEBRUARY',
  '/payments?month=MARCH',
  '/payments?month=APRIL',
  '/payments?month=MAY',
  '/payments?month=JUNE',
  '/payments?month=JULY',
  '/payments?month=AUGUST',
  '/payments?month=SEPTEMBER',
  '/payments?month=OCTOBER',
  '/payments?month=NOVEMBER',
  '/payments?month=DECEMBER',
];

export const allowedPathWithOptionalParams: IPath[] = [
  '/orders/new' as IPath,
  '/orders/edit' as IPath,
  '/preorders/new' as IPath,
  '/preorders/edit' as IPath,
  '/orders/new-internal' as IPath,
  '/contacts/edit' as IPath, // TODO #12345 these will also be removed once we introduce new contact editing concept without subpages
  '/contacts/new' as IPath, // TODO #12345 these will also be removed once we introduce new contact editing concept without subpages
  '/positions/edit' as IPath,
  '/positions/copy' as IPath,
  '/payments' as IPath,
];

export const allowedAreas: IArea[] = ['UK', 'EUROPE', 'OTHER'];

const allowedOpenOrderStatuses: IOrderStatus[] = ['SHIPPED', 'NEW', 'BEING_PREPARED', 'DECLINED', 'FLAWED'];

/** @public */
export const allowedOrderStatuses: IOrderStatus[] = [
  ...allowedOpenOrderStatuses,
  'DELIVERED',
  'INTERNAL_ORDER_COMPLETED',
];

export const allowedPaymentIntervals: IPaymentInterval[] = ['MONTHLY', 'QUARTERLY', 'HALF_YEARLY', 'YEARLY'];
export const allowedPaymentIntervalXMonths: IPaymentIntervalXMonths[] = ['x', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export const allowedOpenPreorderStatuses: IPreorderStatus[] = ['PREORDER'];

export const allowedPreorderStatuses: IPreorderStatus[] = [...allowedOpenPreorderStatuses, 'PREORDER_COMPLETED'];

export const pageHeaderHeight = '50px';
export const paginationFooterHeight = '100px';
export const pageNumberButtonsMaxWidth = 'min(360px, 80dvw)';
export const appHeaderHeight = '80px';
export const basePadding = '12px';

export const statusCategoryColorMapping: Record<IStatusCategory, string> = {
  INFO: colors.black,
  SUCCESS: colors.success,
  WARN: colors.initialized,
  ERROR: colors.error,
};

export const statusCategoryColorMappingBright: Record<IStatusCategory, string> = {
  INFO: colors.white,
  SUCCESS: colors.success,
  WARN: colors.initialized,
  ERROR: colors.error,
};

export const dotDelimiter = encode('·');

export const intervalMs = 10000;
